import { inr, inrShort, num } from "@/lib/api";

const mat = (result, key) => result.materials.find((m) => m.key === key);

// Rendered off-screen; captured to PNG via html2canvas. Uses plain inline
// styles + solid hex colors so the capture is reliable.
export const ShareCard = ({ result, pmay }) => {
  if (!result) return null;
  const cement = mat(result, "cement");
  const steel = mat(result, "steel");
  const net = pmay && pmay.eligible ? result.total_cost - pmay.estimated_subsidy : null;

  const box = { background: "#131C2E", border: "1px solid #23324a", borderRadius: 16, padding: 22 };
  const label = { color: "#94a3b8", fontSize: 20, margin: 0, letterSpacing: 0.4 };
  const big = { color: "#fff", fontSize: 38, fontWeight: 800, margin: "6px 0 0", fontFamily: "Outfit, sans-serif" };

  return (
    <div
      id="share-card"
      className="no-print"
      style={{
        position: "fixed",
        left: -99999,
        top: 0,
        width: 1080,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background: "#0B0F17",
        color: "#fff",
      }}
    >
      {/* Header */}
      <div style={{ background: "#F97316", padding: "36px 44px", display: "flex", alignItems: "center", gap: 20 }}>
        <img
          src="/nirmandwar_logo_mark.png"
          alt="NirmanDwar"
          crossOrigin="anonymous"
          style={{ width: 84, height: 84, borderRadius: "50%", background: "#fff", objectFit: "cover" }}
        />
        <div>
          <div style={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, fontSize: 40, lineHeight: 1 }}>
            NirmanDwar<span style={{ fontSize: 20, verticalAlign: "super" }}>™</span>
          </div>
          <div style={{ fontSize: 22, opacity: 0.9, marginTop: 4 }}>Construction Cost Estimate · nirmandwar.com</div>
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: 44 }}>
        <p style={{ ...label, textTransform: "uppercase", fontWeight: 700, color: "#fb923c" }}>
          Estimated Construction Cost
        </p>
        <div style={{ display: "flex", alignItems: "baseline", gap: 16, flexWrap: "wrap" }}>
          <div style={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, fontSize: 76, color: "#fff", lineHeight: 1 }}>
            ₹{inr(result.total_cost)}
          </div>
          <div style={{ fontSize: 34, color: "#fbbf24", fontWeight: 700 }}>({inrShort(result.total_cost)})</div>
        </div>
        <div style={{ marginTop: 16, fontSize: 24, color: "#cbd5e1" }}>
          {result.inputs.city} · {result.inputs.quality} · {inr(result.inputs.total_area)} sq.ft ·
          ₹{inr(result.cost_per_sqft)}/sq.ft
        </div>

        {/* Stat tiles */}
        <div style={{ display: "flex", gap: 20, marginTop: 30 }}>
          <div style={{ ...box, flex: 1 }}>
            <p style={label}>TOTAL AREA</p>
            <p style={big}>{inr(result.inputs.total_area)}</p>
            <p style={{ ...label, fontSize: 18 }}>sq.ft · {result.inputs.floors} floors</p>
          </div>
          <div style={{ ...box, flex: 1 }}>
            <p style={label}>CEMENT</p>
            <p style={big}>{num(cement.quantity)}</p>
            <p style={{ ...label, fontSize: 18 }}>bags</p>
          </div>
          <div style={{ ...box, flex: 1 }}>
            <p style={label}>STEEL (TMT)</p>
            <p style={big}>{num(steel.quantity)}</p>
            <p style={{ ...label, fontSize: 18 }}>kg</p>
          </div>
        </div>

        {/* Net after subsidy */}
        {net !== null && (
          <div
            style={{
              marginTop: 24,
              background: "#052e21",
              border: "1px solid #10B981",
              borderRadius: 16,
              padding: 22,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ color: "#6ee7b7", fontSize: 22, fontWeight: 700 }}>
              After PMAY subsidy (−₹{inr(pmay.estimated_subsidy)})
            </div>
            <div style={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, fontSize: 40, color: "#fff" }}>
              ₹{inr(net)}
            </div>
          </div>
        )}

        {/* Material mini list */}
        <div style={{ ...box, marginTop: 24, padding: "8px 22px" }}>
          {["sand", "aggregate", "bricks", "paint"].map((k) => {
            const m = mat(result, k);
            return (
              <div
                key={k}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "14px 0",
                  borderBottom: "1px solid #23324a",
                  fontSize: 22,
                }}
              >
                <span style={{ color: "#cbd5e1" }}>{m.label}</span>
                <span style={{ color: "#fff", fontWeight: 700 }}>
                  {num(m.quantity)} {m.unit}
                </span>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: 28, fontSize: 20, color: "#64748b" }}>
          Get your free estimate & compare material prices from 1,700+ suppliers at nirmandwar.com
        </div>
      </div>
    </div>
  );
};
